


























import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { PROrders } from '@/modules/sklad/PROrders';

import PRInvoiceSelect from './components/Select.vue';
import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		PrordersSelect: PROrders.components.Select,
		PRInvoiceSelect,
	},
	computed: {
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${listMutations.ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER}`,
				prorders: `${this.storeUri}/${listMutations.ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		processClick(event: any) {
			const invoiceId = event.data.PR_INVOICE_PAYMENT_ID > 0 ? event.data.PR_INVOICE_PAYMENT_ID : event.data.ID;
			openEdit(NAME, PageMode.EDIT, { id: invoiceId, isZpracujMode: true });
		},
	},
});
